import * as constants from '../../constants';
import Test from '../../test';
import sectionTitle from '../../shared-ui/section-title';
import sectionBody from '../../shared-ui/section-body';
import textButton from '../../shared-ui/text-button';
import newScoreBar from './score-bar';
import { panelHeight, resultPanel } from './tt-result-panel';

export const summaryScreen = new PIXI.Container();
summaryScreen.visible = false;

const screenSectionTitle = sectionTitle('YOUR QUIZ SUMMARY');
const bodyBg = sectionBody(constants.screenBodyHeight);
bodyBg.position.set(0, constants.screenHeaderHeight);

const overallScoreContainer = new PIXI.Container();
overallScoreContainer.position.set(0, constants.screenHeaderHeight);

const overallScoreTitle = new PIXI.Text('YOUR RESULTS:', { font: '15px Open Sans, Arial', fill: 0xFFFFFF });
const overallScoreText = new PIXI.Text('', { font: '25px Open Sans, Arial', fill: 0xFFFFFF });
overallScoreText.anchor.set(1, 0.5);
overallScoreTitle.position.set(30, 10);
overallScoreText.position.set(110, 55);
[ overallScoreTitle, overallScoreText ].forEach(elm => overallScoreContainer.addChild(elm));
let overallScoreBar;


const panelsContainer = new PIXI.Container();
panelsContainer.position.set(0, 130);

const mainMenuBtn = textButton({ text: 'MAIN MENU', bgColour: constants.lightBlue, height: 50 });
mainMenuBtn.anchor.set(0.5, 0);
mainMenuBtn.position.set(constants.screenWidth / 2, constants.screenHeaderHeight + constants.screenBodyHeight - 35);

[ screenSectionTitle, bodyBg, overallScoreContainer, panelsContainer, mainMenuBtn ].forEach(elm => summaryScreen.addChild(elm));

let currentTest;

Test.eventEmitter.on('TEST_END', test => {
  currentTest = test;

  const overallScore = test.score;
  overallScoreText.text = `${ overallScore.correct }/${ overallScore.total }`;

  if ( overallScoreBar ) {
    overallScoreContainer.removeChild(overallScoreBar);
  }
  overallScoreBar = newScoreBar(230, 10, overallScore.correct, overallScore.total);
  overallScoreContainer.addChild(overallScoreBar);
  overallScoreBar.position.set(overallScoreText.x + 20, overallScoreText.y);

  panelsContainer.removeChildren();
  for ( let i = 0; i < test.timestables.length; i++ ) {
    const x = ( constants.screenWidth / 2 ) * ( i % 2 );
    const y = Math.floor(i / 2) * panelHeight;
    const panel = resultPanel(test, test.timestables[ i ]);
    panelsContainer.addChild(panel);
    panel.position.set(x, y);
  }
});

mainMenuBtn.on('pointerdown', () => {
  currentTest.exit();
  currentTest = null;
});
